import React from 'react';
import {ErrorMessage, Form, Formik} from 'formik';
import InputText from 'components/InputText';
import Button from 'components/Button';
import Title from 'components/Typography/Title';
import {ErrorIcon} from 'icons';

import AuthForm from '../../components/AuthForm';
import validate from './resetPasswordValidations';
import {resetPassword} from './resetPasswordHelpers';
import './resetPasswordHelpers.scss';

const initialValues = {email: ''};

export default () => (
  <AuthForm className="reset-password">
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={resetPassword}
      render={({isSubmitting, isValid, submitCount, status}) => {
        if (status === 'sent') {
          return (
            <Form>
              <p>We have sent an email with reset password instructions to the specified email address</p>
            </Form>
          );
        }

        return (
          <Form>
            <Title text="Reset Password" />
            <InputText type="email" name="email" placeholder="Email Address" />

            <footer>
              <Button disabled={isSubmitting}>Reset Password</Button>
            </footer>

            {/* TODO create unit test */}
            {submitCount > 0 && !isValid && (
              <div className="errors">
                <ErrorIcon />
                <ErrorMessage name="email" />
                <ErrorMessage name="password" />
              </div>
            )}
          </Form>
        );
      }}
    />
  </AuthForm>
);
